import api from '~/services/api';
import apiBearer from '~/services/apiBearer';


import Franquias from "../services/Franquias"

var state = null;
const refera_url = "https://admin.refera.com.br/solicitar-manutencao/apolar";
var full_user = null;
var property = null;
var full_property = null
var full_inquiline = null

const refera = {

    async init(state) {

        const token = state.auth.token;
        apiBearer.defaults.headers.Authorization = `Bearer ${token}`;

        full_user = state.user.profile;
        property = state.property.property;

        // await apiBearer.get("/api/v1/WSListaImovel?referencia=" + property.reference).then(
        //     response => {
        //         full_property = response.data.conteudo[0]
        //     },
        //     error => {
        //         console.error(error);
        //     }
        // )

        // await api.get('/api/v1/WSFix', {
        //     params: {
        //         contrato: property.contract
        //         ? property.contract
        //         : property.businessId,
        //     }
        // }).then(
        //     response => {
        //         full_inquiline = response.data.conteudo
        //     }
        // )

    },

    async get_data(property) {

        var promise_1 = new Promise((resolve, reject)=>{
            apiBearer.get("/api/v1/WSListaImovel?referencia=" + property.referencia).then(
                response => {
                    resolve(response.data.conteudo.find(
                        item => item.referencia === property.referencia
                    ))
                },
                error => {
                    console.error(error);
                }
            )
        })

        var promise_2 = new Promise((resolve, reject)=>{
            apiBearer.get("/api/v1/WSFix?Contrato=" + ( typeof property.idContrato != 'undefined' ? property.idContrato : property.contract )).then(
                response => {
                    resolve(response.data.conteudo)
                },
                error => {
                    console.error(error);
                }
            )
        })

        return Promise.all([promise_1, promise_2])
    },

    async open(property) {

        var [full_property, full_inquiline] = await this.get_data(property)

        let property_owner = full_user.tipoCliente.indexOf('Proprietário') != -1 ? full_user : null

        let cep = full_inquiline && full_inquiline.cep ? full_inquiline.cep : ""
        if (cep) {
            cep = cep.replace(/\D/g,'')
            cep = cep.slice(0, 5) + '-' + cep.slice(5);
        }

        let params = {
            "tipo": full_user.tipoCliente.indexOf('Proprietário') == -1 ? "lessee_client" : "property_owner_client",
            "nomeInquilino": full_inquiline ? full_inquiline.nomeInquilino : property_owner.nome,
            "emailInquilino": full_inquiline ? full_inquiline.emailInquilino :  property_owner.email,
            "celularInquilino": full_inquiline ? full_inquiline.celularInquilino : (property_owner && property_owner.celular.length > 0 ? property_owner.celular[0] : ""),
            "cpfInquilino": full_inquiline ? full_inquiline.cpfInquilino : property_owner.documento,
            "endereco": full_inquiline && full_inquiline.endereco ? full_inquiline.endereco : property.endereco,
            "numero": full_inquiline && full_inquiline.numero ? full_inquiline.numero : "",
            "complemento": full_inquiline && full_inquiline.complemento ? full_inquiline.complemento : "",
            "bairro": full_inquiline && full_inquiline.bairro ? full_inquiline.bairro : "",
            "cidade": full_inquiline && full_inquiline.cidade ? full_inquiline.cidade : "",
            "uf": full_inquiline && full_inquiline.uf ? full_inquiline.uf : "",
            "cep": cep,
            "codigo": ( typeof property.referencia != 'undefined' ? property.referencia : property.reference ),
            "nomeProprietario": full_inquiline.nomeProprietario,
            "celularProprietario": full_inquiline.celularProprietario,
            "emailProprietario": full_inquiline.emailProprietario,
            "cpfProprietario": full_inquiline.cpfProprietario,
            "inicioContrato": full_inquiline && full_inquiline.inicioContrato ? full_inquiline.inicioContrato: "",
            "vlrAluguel": full_inquiline && full_inquiline.vlrAluguel ? full_inquiline.vlrAluguel: ""
        }

        let codigo_franquia = full_property['codigoFranquia'] == '347' ? '303' : full_property['codigoFranquia']
        let franquia = await Franquias.getFranquia(codigo_franquia)

        //console.log("franquia: ", franquia)
        let url = `${refera_url}?${new URLSearchParams(params).toString()}`
        
        if ( typeof franquia['Link_Refera'] != 'undefined' &&  franquia['Link_Refera']  && franquia['Link_Refera'] != '') {
            url = `${franquia['Link_Refera']}?${new URLSearchParams(params).toString()}`
        } else {
            let phone = franquia['WhatsApp_Loja'].replace(/\D/g,'')
            let contract_num = typeof property.idContrato != 'undefined' ? property.idContrato : property.contract
            let msg = `Olá! Meu nome é ${params['nomeInquilino']}, gostaria de falar sobre solicitação de reparos. Contrato: ${contract_num} / Referência: ${full_property['referencia']}.`
            url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(msg)}`
        }

        //window.open(url, '_blank').focus();
        var win = window.open(url,'_blank');
        if(win) {
            window.focus();
        } else{
            var timer = window.setTimeout( function(){ if(win)win.focus(); }, 100 );
        }
    }

};
  
  export default refera;
  